<template>
  <div class="textarea-view">
    <span class="textarea-view__label">{{ title }}</span>
    <div class="textarea-view__only-print">
      <b>{{ title }}: </b>
      {{ value || '-' }}
    </div>
    <textarea
      class="textarea-view__input"
      disabled="disabled"
      v-bind:aria-label="title"
      v-bind:rows="rows"
      v-bind:value="value" />
    <button
      v-if="isShowCleanerButton"
      class="textarea-view__cross-cleaner"
      type="button"
      title="Очистить"
      v-on:click="onClean"
    />
  </div>
</template>
<script>
/**
 * @description Просмотр многострочного ввода.
 * @type {Vue}
 */
export default {
  name: 'TextareaView',
  methods: {
    /**
     * @description Очистить поле
     * @returns {void}
     */
    onClean() {
      this.$emit('clean');
    },
  },
  props: {
    /**
     * @description Количество строк.
     * @type {number}
     */
    rows: {
      default: () => 1,
      type: Number,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: {
      required: true,
      type: String,
    },
    /**
     * @description Текст.
     * @type {string}
     */
    value: {
      required: true,
      type: String,
    },
    /**
     * @description Показывать кнопку очистки
     * @type {boolean}
     */
    isShowCleanerButton: {
      default: () => false,
      required: false,
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.textarea-view {
  position: relative;
}

.textarea-view:focus {
  background-color: var(--primary-background-color);
  border: 2px solid var(--action-color);
  margin: 0;
  outline: 0;
}

.textarea-view .textarea-view__input {
  appearance: none;
  background: var(--primary-background-color);
  border-radius: 4px;
  border: 1px solid var(--border-color);
  color: #626262;
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 2px 0;
  outline: none;
  padding: 10px;
  pointer-events: all;
  width: 100%;
}

.textarea-view .textarea-view__label {
  color: var(--unfocus-color);
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.textarea-view .textarea-view__cross-cleaner {
  position: absolute;
  top: 30px;
  right: 14px;
  width: 17px;
  height: 17px;
  background-image: url("@/assets/img/cross/cross-rounded-grey.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 11px 11px;
  cursor: pointer;
  transition: background-image 0.3s;
  &:hover {
    background-image: url("@/assets/img/cross/cross-rounded-blue.svg");
  }
}

.textarea-view .textarea-view__only-print {
  display: none;
}

@media print {
  .textarea-view .textarea-view__input {
    display: none;
  }
  .textarea-view .textarea-view__only-print {
    display: block;
  }
}
</style>
